<p-panel header="{{'pages_titles.users_anonyms.list' | translate}}">

    <app-loader *ngIf="loadingSpinner"></app-loader>

    <ng-template pTemplate="icons">
        <button *ngIf="!noDataFound" pButton class="p-panel-header-icon p-link" (click)="exportAsXLSX()">
            <span class="pi pi-download"></span>
        </button>
    </ng-template>

    <div *ngIf="noDataFound && !loadingSpinner" class="text-center ">
        <img src="assets/images/empty-data.png" class="responsive-image" alt="empty-data-image" />
        <p class="no-data-found w-100">{{'userAnonymListVide' | translate}}</p>
    </div>
    <form *ngIf="!noDataFound" class="w-100 center" [formGroup]="getFiltersForm">

        <input pInputText (ngModelChange)="paginateChange($event);onFilterChange()" class="search-global "
            placeholder="{{'Start_recherche'| translate}}" type="text" name="searchTextUsername"
            formControlName="searchTextUsername" />

        <table class="table-form" #dataTable="mfDataTable" [mfData]="employeesAnonymous" #mf="mfDataTable"
            [mfRowsOnPage]="10">

            <thead class="thead-form">
                <tr>

                    <th scope="col">
                        <mfDefaultSorter by="username">{{'Username' | translate}}</mfDefaultSorter>
                    </th>
                    <th scope="col">
                        <mfDefaultSorter by="email">{{'Email' | translate}}</mfDefaultSorter>
                    </th>

                </tr>
            </thead>
            <tbody>
                <tr class="not-display"></tr>
                <tr class="not-display">
                    <td>
                        <div>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText (ngModelChange)="paginateChange($event);onFilterChange()"
                                    placeholder="{{'Start_recherche'| translate}}" type="text" name="searchTextUsername"
                                    formControlName="searchTextUsername" />
                            </span>
                        </div>
                    </td>

                    <td>
                        <div>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText (ngModelChange)="paginateChange($event);onFilterChange()"
                                    placeholder="{{'Start_recherche'| translate}}" type="text" name="searchTextEmail"
                                    formControlName="searchTextEmail" />
                            </span>
                        </div>
                    </td>


                </tr>
                <tr
                    *ngFor="let employeesAnonymous of mf.data | grdFilter: {email: searchText, username:searchText}; index as i">
                    <td attr.data-label="{{'Username' | translate}}">
                        <p class="text-center overflow-auto"><strong>{{employeesAnonymous.username | maskText}}</strong>
                        </p>
                    </td>
                    <td attr.data-label="{{'Email' | translate}}">
                        <p class="text-center overflow-auto">{{employeesAnonymous.email | maskText}}</p>
                    </td>

                </tr>

            </tbody>
            <tfoot>
                <tr>
                    <td colspan="2">
                        <mfBootstrapPaginator #Paginator [rowsOnPageSet]="[10,25,50,75]"></mfBootstrapPaginator>
                    </td>
                </tr>
            </tfoot>
        </table>
        <div *ngIf="noDataSearch && !noDataFound" class="no-data-search">
            <img src="assets/images/empty-data.png" class="responsive-image" alt="empty-data-image" />
            <p class="no-data-found w-100">{{'NO_DATA_SEARCH' | translate}}</p>
        </div>
    </form>

</p-panel>